import styled from 'styled-components';
import Text from 'shared/components/Text/Text';

export const StrongText = styled(Text)`
  font-size: 16px;
  font-weight: 800;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.textPrimarySecondary1100};
  display: inline;
  word-break: break-word;
`;

export const VerificationForm = styled.form`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`;

export const VerifyingSpinnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 8px;
`;

export const VerifyingText = styled(Text)`
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.textSecondaryGrey90};
`;
